import React from "react";

const SummaryCard = ({ title, value, subtitle, progress, trend, color = "blue" }) => {
  return (
    <div className={`summary-card ${color}`}>
      <h4 className="sc-title">{title}</h4>
      <span className="bg-circle" style={{ backgroundColor: color }}></span>
      <h2 className="sc-value">{value}</h2>
      <div className="progress" style={{ height: 6, background: '#dbe2ea', borderRadius: 6 }}>
        <div
          className="progress-bar"
          role="progressbar"
          style={{ width: `${progress}%`, borderRadius: 6 }}
          aria-valuenow={progress}
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
      <p className={`sc-trend ${trend > 0 ? "up" : "down"}`}>
        {trend > 0 ? "\u25B2" : "\u25BC"} {Math.abs(trend)}% vs last month
      </p>
      <p className="sc-subtitle">{subtitle}</p>
    </div>
  );
};

export default SummaryCard;
